/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flavor_UpdatedInputs */

const en_flavor_updated = /** @type {(inputs: Flavor_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flavor updated`)
};

const es_flavor_updated = /** @type {(inputs: Flavor_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sabor actualizado`)
};

/**
* | output |
* | --- |
* | "Flavor updated" |
*
* @param {Flavor_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const flavor_updated = /** @type {((inputs?: Flavor_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flavor_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flavor_updated(inputs)
	return es_flavor_updated(inputs)
});